import { Container, Row } from 'react-bootstrap';
import styled from 'styled-components';

import loginLeft from '../../../assets/svg/login-left.svg';
import loginRight from '../../../assets/svg/login-right.svg';
import LoopLogoMobile from '../../../assets/svg/loop-optimise-logo-mobile.svg';
import LoopLogoWhite from '../../../assets/svg/loop-optimise-logo-white.svg';
import { max, min } from '../../../utils/breakpoints';

const LoopStyledContainer = styled(Container)`
  background-color: ${(props) => props.theme.colors.dark};
  background-image: url(${loginLeft});
  background-position: left top;
  background-repeat: no-repeat;
  background-size: auto 100%;
  z-index: 100;

  ${max.sm} {
    background-image: none;
  }
`;

const StyledRightBgDiv = styled.div`
  background: url(${loginRight}) right top no-repeat;
  background-size: auto 100%;
  z-index: 0;
`;

const StyledLogoImg = styled.img`
  z-index: 1;
  display: none;

  ${min.md} {
    display: block;
  }
`;

const StyledLogoImgMobile = styled.img`
  z-index: 1;
  display: block;

  ${min.md} {
    display: none;
  }
`;

const LoginBackgroundRight = (
  <StyledRightBgDiv className="position-fixed vh-100 vw-100 fixed-top d-none d-sm-block"></StyledRightBgDiv>
);

const LoopLoginLayout = ({ children }) => {
  return (
    <LoopStyledContainer
      fluid
      className="d-flex flex-column align-content-between justify-content-between login-background"
    >
      {LoginBackgroundRight}
      <Row className="p-lg-5 p-md-4 p-3 justify-content-center">
        <StyledLogoImg src={LoopLogoWhite} alt="Loop Optimise" />
        <StyledLogoImgMobile src={LoopLogoMobile} alt="Loop Optimise" />
      </Row>
      <Row className="p-lg-5 p-md-4 p-3 justify-content-center">{children}</Row>
      <Row className="p-lg-5 p-md-4 p-3">
        {/* This empty row is here so flex-box keeps the login card vertically centred */}
      </Row>
    </LoopStyledContainer>
  );
};

export default LoopLoginLayout;
